module.exports = __webpack_public_path__ + "static/media/menu-dots.5648c1fa.svg";